import { render, staticRenderFns } from "./serviceEntrance.vue?vue&type=template&id=092f7c28&scoped=true"
import script from "./serviceEntrance.vue?vue&type=script&lang=js"
export * from "./serviceEntrance.vue?vue&type=script&lang=js"
import style0 from "./serviceEntrance.vue?vue&type=style&index=0&id=092f7c28&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092f7c28",
  null
  
)

export default component.exports